import React from "react";

import { Flex, Icon, IStyleSize } from "@/eworkitComponents";

interface Style extends IStyleSize {}

interface Props extends Partial<Style> {
  children: JSX.Element | JSX.Element[];
  icon: string;
}

export const IconGroup: React.FunctionComponent<Props> = React.memo(({ children, icon, size = "md" }) => {
  const paddings: { [key: string]: string } = {
    lg: "sm",
    md: "xs",
  };

  return (
    <Flex grow={1} direction="row" innerMargin={paddings[size]}>
      <Flex padding={[paddings[size], false]}>
        <Icon icon={icon} color="secondary" size={size} />
      </Flex>
      <Flex grow={1} direction="column" justify="center">
        {children}
      </Flex>
    </Flex>
  );
});
